import {Country, City} from 'country-state-city';
import {ICountry, ICity} from 'country-state-city/dist/lib/interface';
import {useState, useEffect} from 'react';

export const useBillingCycleState = () => {
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [cities, setCities] = useState<ICity[]>([]);
  const [addressSaved, setAddressSaved] = useState(false);
  const [line1, setLine1] = useState('');
  const [openDrawer, setOpenDrawer] = useState(false);
  const [coupon, setCoupon] = useState<string>('');

  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  useEffect(() => {
    setCities(
      selectedCountry ? City.getCitiesOfCountry(selectedCountry) || [] : [],
    );
  }, [selectedCountry]);

  return {
    countries,
    selectedCountry,
    setSelectedCountry,
    cities,
    addressSaved,
    setAddressSaved,
    line1,
    setLine1,
    openDrawer,
    setOpenDrawer,
    coupon,
    setCities,
    setCoupon,
  };
};
